import { useMutation } from "@shared/lib/hooks";
import { CampaignService } from "../services/Campaign.service";
import { ToastService } from "@shared/lib/services";
import {
  BRIEF_CAMPAIGN_FACETS_QUERY_KEY,
  BRIEF_CAMPAIGNS_LIST_QUERY_KEY,
} from "../contsants";

export function useAssignOperationsPoc(briefId: string) {
  const {
    mutate: assignOperationsPoc,
    isLoading: isAssigning,
    isSuccess: isAssigned,
  } = useMutation({
    mutationFn: (data: {
      briefInfluencerId: string[];
      assignedToUserId: string;
    }) =>
      CampaignService.assignOperationsPoc(
        data.briefInfluencerId,
        data.assignedToUserId
      ).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      }),
    options: {},
    onSuccess: (c) => {
      c.invalidateQueries({
        queryKey: BRIEF_CAMPAIGNS_LIST_QUERY_KEY(briefId),
      });
      c.invalidateQueries({
        queryKey: BRIEF_CAMPAIGN_FACETS_QUERY_KEY(briefId),
      });
    },
  });

  return {
    assignOperationsPoc,
    isAssigning,
    isAssigned,
  };
}
